import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
import { getHeaderActionType } from "../helpers";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";

/**
 * CRETE API call using Axios
 * @returns - Create All Shortage Investigation create and update API and return same object
 */

export const ShortageInvestigationCreateUpdateAPI = async (
  params: any,
  osdNumber: string,
  action: string = "save",
  day?: string,
  osdType: string = "AS",
) => {
  try {
    // Get static headers from map (do not use || {})
    const staticHeaders = getTrackingHeadersMap(ApiType.SHORTAGE_INVESTIGATION);
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Action-Type": getHeaderActionType(action),
      "OSD-Exception-Number": osdNumber?.toString(),
      "OSD-Exception-Type": osdType,
    };
    const response = await axios.post(
      `${getUrl(ApiType.SHORTAGE_INVESTIGATION)
        .replace(":osdNumber", osdNumber)
        .replace(":day", day!)
        .replace(":action", action)
      }`,
      params,
      { headers },
    );
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.createUpdateShortageInvestigation);
  }
};
